import { render, staticRenderFns } from "./OrderItens.vue?vue&type=template&id=19f15ea8"
import script from "./OrderItens.vue?vue&type=script&lang=js"
export * from "./OrderItens.vue?vue&type=script&lang=js"
import style0 from "./OrderItens.vue?vue&type=style&index=0&id=19f15ea8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports